document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quantity-change]');
  if (!button) return;

  const input = document.querySelector(button.getAttribute('data-quantity-change'));
  if (!input) return;

  const step = button.dataset.step === 'minus' ? -1 : 1;
  const nextValue = Math.max(Number(input.value || 1) + step, 1);
  input.value = nextValue;
});

const headerSubmenus = Array.from(document.querySelectorAll('.tiv-header__nav-item.has-submenu'));
const mobileMenu = document.querySelector('[data-mobile-menu]');
const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
const mobileMenuCloseButtons = Array.from(document.querySelectorAll('[data-mobile-menu-close]'));
const filterDrawer = document.querySelector('[data-filter-drawer]');
const filterDrawerToggle = document.querySelector('[data-filter-drawer-toggle]');
const filterDrawerCloseButtons = Array.from(document.querySelectorAll('[data-filter-drawer-close]'));

const closeHeaderSubmenus = (exceptItem) => {
  headerSubmenus.forEach((item) => {
    if (item !== exceptItem) item.open = false;
  });
};

const closeMobileMenu = () => {
  document.body.classList.remove('tiv-mobile-menu-open');
  if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
  closeHeaderSubmenus();
};

const openMobileMenu = () => {
  closeFilterDrawer();
  document.body.classList.add('tiv-mobile-menu-open');
  if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
};

const closeFilterDrawer = () => {
  document.body.classList.remove('tiv-filter-drawer-open');
  if (filterDrawerToggle) filterDrawerToggle.setAttribute('aria-expanded', 'false');
};

const openFilterDrawer = () => {
  closeMobileMenu();
  document.body.classList.add('tiv-filter-drawer-open');
  if (filterDrawerToggle) filterDrawerToggle.setAttribute('aria-expanded', 'true');
};

if (mobileMenuToggle && mobileMenu) {
  mobileMenuToggle.addEventListener('click', () => {
    if (document.body.classList.contains('tiv-mobile-menu-open')) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });
}

mobileMenuCloseButtons.forEach((button) => {
  button.addEventListener('click', closeMobileMenu);
});

if (filterDrawerToggle && filterDrawer) {
  filterDrawerToggle.addEventListener('click', () => {
    if (document.body.classList.contains('tiv-filter-drawer-open')) {
      closeFilterDrawer();
    } else {
      openFilterDrawer();
    }
  });
}

filterDrawerCloseButtons.forEach((button) => {
  button.addEventListener('click', closeFilterDrawer);
});

headerSubmenus.forEach((item) => {
  item.addEventListener('toggle', () => {
    if (item.open) closeHeaderSubmenus(item);
  });

  item.addEventListener('click', (event) => {
    if (event.target.closest('.tiv-header__submenu-card')) {
      item.open = false;
      closeMobileMenu();
    }
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.tiv-header__nav')) {
    closeHeaderSubmenus();
  }

  if (
    document.body.classList.contains('tiv-mobile-menu-open')
    && event.target.closest('.tiv-header__nav-link')
    && !event.target.closest('.tiv-header__nav-item')
  ) {
    closeMobileMenu();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeHeaderSubmenus();
    closeMobileMenu();
    closeFilterDrawer();
  }
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-product-gallery-thumb]');
  if (!thumb) return;

  const gallery = thumb.closest('.product-gallery');
  const productMain = thumb.closest('.product-main');
  const image = gallery?.querySelector('[data-product-gallery-image]');
  if (!image) return;

  image.src = thumb.dataset.fullSrc;
  image.alt = thumb.dataset.alt || '';

  gallery.querySelectorAll('[data-product-gallery-thumb]').forEach((item) => {
    item.classList.toggle('is-active', item === thumb);
  });

  const variantId = thumb.dataset.variantId;
  const variantSelect = productMain?.querySelector('[data-product-variant-select]');
  if (variantId && variantSelect && variantSelect.value !== variantId) {
    variantSelect.value = variantId;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('change', (event) => {
  const variantSelect = event.target.closest('[data-product-variant-select]');
  if (!variantSelect) return;

  const productMain = variantSelect.closest('.product-main');
  const selectedOption = variantSelect.selectedOptions?.[0];
  if (!productMain || !selectedOption) return;

  const priceTarget = productMain.querySelector('[data-product-price] .price');
  if (priceTarget && selectedOption.dataset.price) {
    const price = selectedOption.dataset.price;
    const compareAtPrice = selectedOption.dataset.compareAtPrice;
    const priceCents = Number(selectedOption.dataset.priceCents || 0);
    const compareAtPriceCents = Number(selectedOption.dataset.compareAtPriceCents || 0);

    if (compareAtPrice && compareAtPriceCents > priceCents) {
      priceTarget.innerHTML = `<s>${compareAtPrice}</s> ${price}`;
    } else {
      priceTarget.textContent = price;
    }
  }

  const mediaId = selectedOption.dataset.featuredMediaId;
  if (!mediaId) return;

  const thumb = productMain.querySelector(`[data-product-gallery-thumb][data-media-id="${mediaId}"]`);
  if (thumb) thumb.click();
});

const initBundleBoostCardBadges = (root = document) => {
  root.querySelectorAll('.bb-card-order-badge, .bb-product-order-badge').forEach(async (el) => {
    if (el.dataset.bbBadgeLoaded === 'true') return;
    el.dataset.bbBadgeLoaded = 'true';

    try {
      const res = await fetch(el.dataset.bbBadgeEndpoint);
      const data = await res.json();

      if (!data.active || !data.badge) return;

      el.textContent = el.dataset.bbBadgeLabel || 'Sur commande';
      el.hidden = false;

      const card = el.closest('.product-card');
      if (card) {
        card.classList.add('has-bb-order-badge');
        const soldOutBadge = card.querySelector('.product-card__badge--sold-out');
        if (soldOutBadge) soldOutBadge.hidden = true;
      }
    } catch (error) {}
  });
};

const initLifestyleCarousels = (root = document) => {
  root.querySelectorAll('[data-lifestyle-carousel]').forEach((carousel) => {
    if (carousel.dataset.lifestyleReady === 'true') return;
    carousel.dataset.lifestyleReady = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-lifestyle-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-lifestyle-dot]'));
    const prev = carousel.querySelector('[data-lifestyle-prev]');
    const next = carousel.querySelector('[data-lifestyle-next]');
    const autoplay = carousel.dataset.autoplay === 'true';
    const interval = Number(carousel.dataset.interval || 5000);
    let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let timer = null;

    if (slides.length <= 1) return;
    if (current < 0) current = 0;

    const setActive = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === current);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === current);
        dot.setAttribute('aria-selected', dotIndex === current ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplay || timer) return;
      timer = window.setInterval(() => setActive(current + 1), interval);
    };

    prev?.addEventListener('click', () => {
      stop();
      setActive(current - 1);
    });

    next?.addEventListener('click', () => {
      stop();
      setActive(current + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stop();
        setActive(index);
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    setActive(current);
    start();
  });
};

initBundleBoostCardBadges();
initLifestyleCarousels();

document.addEventListener('shopify:section:load', (event) => {
  initBundleBoostCardBadges(event.target);
  initLifestyleCarousels(event.target);
});